import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'copyright-note',
  templateUrl: './copyright.note.html',
})
export class CopyrightNote {
  currentYear: number = new Date().getFullYear();
}
